import { ca } from '@cian/analytics';

export function trackReliableMoreClick(newbuildingId: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'JK_problems_more_click',
    label: `green/${newbuildingId}`,
    useLastProducts: true,
  });
}

export const trackGoToReliableHouseListing = (houseId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'click_reliability_block',
    label: houseId,
    useLastProducts: true,
  });
};
